export default __webpack_public_path__ + "static/media/del2.ac55bf41.png";